import { render, staticRenderFns } from "./attendee-guide.vue?vue&type=template&id=685c4af4&scoped=true&"
import script from "./attendee-guide.vue?vue&type=script&lang=js&"
export * from "./attendee-guide.vue?vue&type=script&lang=js&"
import style0 from "./attendee-guide.vue?vue&type=style&index=0&id=685c4af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c4af4",
  null
  
)

export default component.exports